import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { statusEnum } from "kubb";
import type React from "react";
import AssetIdLink from "../../../../components/Asset/AssetIdLink";
import GetAssetRegisterEntitiesCombination from "../../../../core/action/GetAssetRegisterEntitiesCombination";

interface Props {
  assetId: string;
  companyId: string;
}

/**
 * Displays a clickable link to a child asset showing its serial number.
 * Opens in a new tab when clicked.
 * Used in instruction rows to link to child devices (CMeX40, wireless receivers).
 */
const ChildAssetLink = (props: Props): React.ReactElement => {
  const { assetId, companyId } = props;

  return (
    <GetAssetRegisterEntitiesCombination
      asset_id={assetId}
      company_id={companyId}
      status={[statusEnum.ACTIVE, statusEnum.DELETED]}
      placeholder={() => (
        <FontAwesomeIcon
          spin
          icon={faSpinner}
          aria-hidden="true"
          className="text-gray-400"
        />
      )}
      error={() => <span className="text-gray-400">-</span>}
    >
      {({ asset }) =>
        asset ? (
          <AssetIdLink asset={asset} text={asset.serial_number} openInNewTab />
        ) : (
          <span className="text-gray-400">-</span>
        )
      }
    </GetAssetRegisterEntitiesCombination>
  );
};

export default ChildAssetLink;
